<template>
  <div class="present">
    <div class="presentLead">
      <HeadingLv2 text="イベント特典をチェック！" icon="present" />
      <p>
        WEBイベントに参加して条件を達成すると素敵なプレゼントが当たる抽選会に参加できます。
      </p>
    </div>
    <!-- <div class="presentBenefits">
      <div class="benefit_item">
        <h3 class="benefit_heading">その1</h3>
        <p class="benefit_lead">
          プレゼント<br class="hiddenPc" />キャンペーン
        </p>
        <p class="benefit_text">
          WEBイベントに参加して条件を達成すると抽選でギフトコードをプレゼント！
        </p>
      </div>
      <div class="benefit_item">
        <h3 class="benefit_heading">その2</h3>
        <p class="benefit_lead">会員登録<br class="hiddenPc" />キャンペーン</p>
        <p class="benefit_text">
          マイナビRESIDENTの会員登録が完了するともれなくギフトコードをプレゼント！
        </p>
      </div>
    </div> -->
    <ul class="presentNote">
      <li>
        ※WEBイベントの抽選会、特典内容はセミナーごとに異なります。詳細はWEBイベントのページをご確認ください。
      </li>
      <!-- <li>
        ※会員登録キャンペーンは「マイナビRESIDENT」への会員登録が必要です。詳細は<TextLink
          text="会員登録キャンペーンページ"
          link="/lp/etc/newregist"
          :hasArrow="false"
        />をご確認ください。
      </li> -->
    </ul>
  </div>
</template>

<script lang="ts">
//import TextLink from '@/components/elements/TextLink.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'

export default {
  name: 'EventPresent',
  components: { HeadingLv2 },
  setup() {
    //
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.presentBenefits {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 0;
  font-size: 1.3rem;
  line-height: 1.46;
}

.benefit_item {
  flex-basis: 48.9%;
  margin-top: 10px;
  padding: 16px 13px 10px;
  border: 2px solid var.$color-main;
  @include mixins.media() {
    flex-basis: calc(50% - 20px);
    margin: 14px 0;
    padding: 16px;
  }
}

.benefit_heading {
  position: relative;
  background-color: var.$color-main;
  color: #fff;
  text-align: center;
  line-height: 27px;
  font-size: 1.4rem;

  &::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 15px 0 15px 10px;
    border-color: transparent transparent transparent #fff;
  }

  &::after {
    display: inline-block;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 15px 10px 15px 0;
    border-color: transparent #fff transparent transparent;
  }
  @include mixins.media() {
    display: inline-flex;
    justify-content: center;
    width: 80px;
  }
}
.benefit_lead {
  margin-top: 9px;
  margin-bottom: 6px;
  text-align: center;
  font-weight: 900;
  color: var.$color-main-text;
  line-height: 1.57;
  @include mixins.media() {
    display: inline-flex;
    font-size: 1.6rem;
    margin: 2px 0 2px 8px;
  }
}
.benefit_text {
  @include mixins.media() {
    margin-top: 8px;
  }
}
.presentNote {
  margin-top: 13px;
  font-size: 1.2rem;
  line-height: 1.5;
  display: grid;
  > li {
    margin-left: 1em;
    text-indent: -1em;
  }
}
.presentLead {
  display: grid;
  gap: 14px;
}
@include mixins.media() {
  .present {
    position: relative;
    display: grid;
  }
  .presentLead {
    padding-top: 10px;
  }
  .presentNote {
    margin-top: 0;
    gap: 8px;
  }
  .presentBenefits {
  }
}
</style>
